import React from "react";

type Props = {
  TitleLabel: string;
  Name: string;
  Placeholder?: string;
  Value?: string;
  OnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const FormInputsText = ({
  TitleLabel,
  Name,
  Placeholder,
  Value,
  OnChange,
}: Props) => {
  return (
    <div className="form-group">
      <label className="develop___text develop___font_text" htmlFor={Name}>
        {TitleLabel}
      </label>
      <input
        type="text"
        className="form-control develop__inputs"
        id={Name}
        name={Name}
        placeholder={Placeholder}
        onChange={OnChange}
        value={Value}
      />
    </div>
  );
};

export default FormInputsText;
